import gql from 'graphql-tag'

import { ProfileFieldsFragment } from './profile'
import { ProfileMediaFieldsFragment } from './profileMedia'

export { ExtendedProfileFields as IExtendedProfile } from './__generated__/ExtendedProfileFields'

export const ExtendedProfileFieldsFragment = gql`
  fragment ExtendedProfileFields on Profile {
    ...ProfileFields
    additionalInfo
    calendars {
      title
      synopsis
      entries {
        date
        reason
      }
    }
    content
    daysPerWeek
    features {
      name
      value
    }
    mealsBreakfastProvided
    mealsDinnerProvided
    mealsLunchProvided
    pottyTrainingRequired
    profileMedia {
      ...ProfileMediaFields
    }
    providerChildRatioConsequent
    rhythm {
      title
      synopsis
      beats {
        time
        activity
      }
    }
    snacksProvidedCount
    networkRating
    programOfferings {
      id
      slug
    }
  }

  ${ProfileFieldsFragment}
  ${ProfileMediaFieldsFragment}
`
